export class Recipe {
    ID: number;
    Title: string;
    Directions: string;
    Ingredients: string;
    Category: string;
    Source: string;
    Cookbook: string;
    Ethnicity: string;
    Notes: string;
}